import SimpleCard from "../components/SimpleCard";

const blogPost = [
    {
        "name": "Birthday Coupons That Add a Personal Touch",
        "description": "Looking for a birthday gift that feels personal and unique? Personalized coupons allow you to craft memorable experiences, from simple treats to exciting activities, making each birthday extra special.",
        "color": "#ff9800"
    },
    {
        "name": "Printable Coupons: Creative Gift Ideas for Any Occasion",
        "description": "Printable coupons are a versatile gift option for any occasion. Customize your designs, add personal messages, and give friends or family an experience that’s meaningful and memorable.",
        "color": "#4caf50"
    },
    {
        "name": "Customizable Invoices for Professionals and Businesses",
        "description": "Whether it's a one-time project or ongoing service, our invoice maker lets you create branded, customizable invoices. Include line items, notes, and payment terms for a professional look every time.",
        "color": "#2196f3"
    },
    {
        "name": "Romantic Coupon Books to Delight Your Partner",
        "description": "Turn ordinary days into special moments with a custom romantic coupon book. Include thoughtful gestures, date nights, and fun surprises to make your relationship even more meaningful.",
        "color": "#e91e63"
    },
    {
        "name": "How to Create Landing Pages That Convert",
        "description": "A great landing page helps your business capture leads and promote products effectively. Choose from professionally designed templates, personalize them with your branding, and launch pages optimized for conversions.",
        "color": "#ff5722"
    }
];

const Blog = () => {
    return (
        <div>
            <header class="blog-header">
                <h1>Create in Wendaspace</h1>
                <h2>Design and customize printable documents, including invoices, coupons, and more, ready to download and print instantly.</h2>
            </header>
            <SimpleCard items={blogPost} />
        </div>
    )
}

export default Blog;